import {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import Container from "@components/layout/Container";
import {client, urlFor} from "@/services/sanityClient";

const CATEGORY_LABEL = {
	single: "Одинарний",
	double: "Подвійний",
	cross: "Хрест",
	"premium-single": "Преміум одинарний",
	"premium-double": "Преміум подвійний",
	child: "Дитячий",
	heroes: "Героям",
};

const ITEMS_QUERY = `*[_type == "catalogItem" && showOnHome == true] | order(order asc, _createdAt desc) [0...3] {
  _id, title, image, category, price
}`;

const GRANITE_QUERY = `*[_type == "graniteType" && showOnHome == true] | order(order asc, _createdAt desc) [0...3] {
  _id, title, image
}`;

export default function CatalogPreview() {
	const [items, setItems] = useState([]);

	useEffect(() => {
		Promise.all([
			client.fetch(ITEMS_QUERY),
			client.fetch(GRANITE_QUERY),
		]).then(([catalogData,]) => {
			setItems(catalogData);
		});
	}, []);

	return (
		<section className="catalog-preview">
			<Container>
				<header className="catalog-header">
					<span className="eyebrow eyebrow--dark">Наш каталог</span>
					<h2 className="catalog-title">Популярні моделі</h2>
					<p className="catalog-sub">
						Виготовляємо пам&apos;ятники будь-якої складності з різних видів каменю. Понад 200 моделей у каталозі.
					</p>
				</header>

				{items.length > 0 && (
					<div className="catalog-grid">
						{items.map((c) => (
							<div key={c._id} className="catalog-card">
								<div className="catalog-card-media">
									{c.image && (
										<img
											src={urlFor(c.image).width(600).height(600).fit("crop").auto("format").url()}
											alt={c.title}
											width="600"
											height="600"
											loading="lazy"
											decoding="async"
											crossOrigin="anonymous"
										/>
									)}
								</div>
								<span className={`catalog-badge${c.category?.startsWith("premium") ? " catalog-badge--gold" : ""}`}>
									{CATEGORY_LABEL[c.category] ?? c.category}
								</span>
								<h3 className="catalog-card-title">{c.title}</h3>
								<p className="catalog-card-price">{c.price}</p>
							</div>
						))}
					</div>
				)}

				<div className="catalog-cta-row">
					<Link to="/catalog" className="btn-catalog">
						Весь каталог
						<span className="arrow" />
					</Link>
				</div>
			</Container>
		</section>
	);
}
